import { CODE_TRANSFORM_ID_MIGRATION_ICONS, transformMigrationIcons } from './migration-icons';
import { transformRelativeImports } from './relative-imports';
import type { CodeTransformIds } from './types';

/**
 * Transforms source code of an example to:
 * - Remove relative paths and replace them with package names
 * - Apply code transformations
 */
export const transformCode = (
	source: string,
	packageName: string,
	options?: {
		/**
		 * A list of code transformations to disable for individual examples.
		 * This is useful for examples that are not compatible with the default code transformations.
		 *
		 * For example, if you want to disable the migration icons code transformation for an example
		 * that demonstrates migration icons.
		 */
		disableCodeTransforms?: CodeTransformIds;
		iconography?: 'legacy' | 'refreshed';
	},
): string => {
	let transformedSource = source;

	transformedSource = transformRelativeImports(source, { packageName });

	if (!options?.disableCodeTransforms?.includes(CODE_TRANSFORM_ID_MIGRATION_ICONS)) {
		transformedSource = transformMigrationIcons(
			transformedSource,
			options?.iconography === 'refreshed' ? 'new' : 'legacy',
		);
	}

	transformedSource = transformedSource.trim();

	return transformedSource;
};
